import React, { useEffect, useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import downloadPdf from "../../assets/images/downloadPdf.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { getShowAgreementHandler } from "../../redux/action/getShowAgreement";
import { useTranslation } from "react-i18next";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import NoDataFound from "../NoDataFound/NoDataFound";
// import { zoomPlugin } from "@react-pdf-viewer/zoom";

const PdfReview = () => {
  const [pdfUrl, setPdfUrl] = useState("");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
// Get all PDF files from state
const pdfFiles = state?.data?.data?.files || [];
const totalPdfs = pdfFiles.length;
const [currentIndex, setCurrentIndex] = useState(0);
// Ensure index is within valid range
const validIndex = totalPdfs > 0 ? Math.max(0, Math.min(currentIndex, totalPdfs - 1)) : 0;
const currentPdf = pdfFiles[validIndex];
  const PDF_INDEX_KEY = "pdfReviewCurrentIndex";

  
  // const zoomPluginInstance = zoomPlugin();
  // const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;

  // useEffect(() => {
  //   dispatch(getShowAgreementHandler());
  // }, []);

  const handleDownload = () => {
    const fileUrl = currentPdf?.fileUrl;
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    } else {
      console.error("File URL is missing");
    }
  };
  useEffect(() => {
    const url = currentPdf?.fileUrl;
    if (url) {
      setPdfUrl(url);
    } else {
      console.error("PDF URL is invalid or missing");
    }
  }, [currentPdf, validIndex, currentIndex]);

  const handleBack = () => {
    // Clear session storage when going back to esign
    sessionStorage.removeItem(PDF_INDEX_KEY);
    navigate("/eSign");
  };

  useEffect(() => {
    const storedIndex = sessionStorage.getItem(PDF_INDEX_KEY);
    if (storedIndex !== null) {
      const parsedIndex = parseInt(storedIndex, 10);
      if (!isNaN(parsedIndex) && parsedIndex >= 0) {
        setCurrentIndex(parsedIndex);
      } else {
        setCurrentIndex(0);
        sessionStorage.setItem(PDF_INDEX_KEY, "0");
      }
    } else {
      // If no stored index, start at 0
      setCurrentIndex(0);
      sessionStorage.setItem(PDF_INDEX_KEY, "0");
    }
  }, []);

  // Update session storage when valid index changes and ensure it's within bounds
  useEffect(() => {
    if (totalPdfs > 0 && validIndex !== currentIndex) {
      // If the current index is out of bounds, correct it
      setCurrentIndex(validIndex);
    }
    // Always update session storage with the valid index
    if (totalPdfs > 0) {
      sessionStorage.setItem(PDF_INDEX_KEY, validIndex.toString());
    }
  }, [validIndex, totalPdfs, currentIndex]);

  const handleContinue = () => {
    const nextIndex = validIndex + 1;
    
    // If there are more PDFs, update index and stay on same page
    if (nextIndex < totalPdfs) {
      setCurrentIndex(nextIndex);
      sessionStorage.setItem(PDF_INDEX_KEY, nextIndex.toString());
    } else {
      // If it's the last PDF, clear session storage and navigate to show-sign-document
      sessionStorage.removeItem(PDF_INDEX_KEY);
      navigate("/dashboard");
    }
  };

  return (
    <>
      <div className="commonHeader">
        <div className="container">
          <div className="headerBg">
            <img
              src={backBtn}
              onClick={handleBack}
              className="cursor-pointer backBtn"
              alt=""
            />
            <img
              src={backBtnMobile}
              onClick={handleBack}
              className="cursor-pointer backBtnMobile"
              alt=""
            />
            <h2 className="tgb">{currentPdf?.fileName||""}</h2>
          </div>
        </div>
      </div>
      <div className="container marginTop80">
        <div className="mx-887 mx-auto h-100 position-relative">
          <div className="pdfReview mb-40">
            {pdfUrl ? (
              <>
                <Worker
                  workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
                >
                   <Viewer fileUrl={pdfUrl} />
                </Worker>
                <div className="downloadPdf" onClick={handleDownload}>
                  <img src={downloadPdf} alt="" />
                </div>
              </>
            ) : (
              <NoDataFound />
            )}
          </div>

          <div className="mx-420 mx-auto p-0">
            <button
              className="primaryButton w-100 mb-40 cursor-pointer fs-18"
              // onClick={() => navigate("/show-sign-document", { state: state })}
              onClick={handleContinue}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfReview;
